module.exports = __webpack_public_path__ + "img/UTN Logo.0711b5ee.png";